import React from 'react';
import { Link } from 'react-router-dom';
import {
  Menu as BPMenu,
  MenuItem as BPMenuItem,
  MenuDivider as BPMenuDivider,
  MenuProps as IMenuProps,
  MenuItemProps as IMenuItemProps,
  MenuDividerProps as IMenuDividerProps
} from '@blueprintjs/core';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import Icon from '../../atoms/icon';

export const Menu: React.FC<IMenuProps> = ({ children, ...props }) => {
  return <BPMenu {...props}>{children}</BPMenu>;
};

export const MenuItem: React.FC<IMenuItemProps> = ({ children, ...props }) => {
  return <BPMenuItem {...props}>{children}</BPMenuItem>;
};

export const MenuDivider: React.FC<IMenuDividerProps> = ({
  children,
  ...props
}) => {
  return <BPMenuDivider {...props}>{children}</BPMenuDivider>;
};

interface MenuItemLinkProps extends Omit<IMenuItemProps, 'icon'> {
  icon: FontAwesomeIconProps['icon'];
}

export const MenuItemLink: React.FC<MenuItemLinkProps> = ({
  href,
  icon,
  text
}) => {
  const onClick = (event: React.MouseEvent) =>
    (event.target as HTMLElement).parentElement.parentElement.click();
  return (
    <li>
      <Link onClick={onClick} to={href} className="bp5-menu-item">
        <span>
          <Icon title={false} icon={icon} />
        </span>
        <div className="bp5-text-overflow-ellipsis bp5-fill">{text}</div>
      </Link>
    </li>
  );
};
